import Cookie from 'js-cookie'

export function setCookie(string, value) {
  const domain = getDomain()
  const secure = needSecure(window.location.protocol)

  Cookie.set(string, value, {
    domain,
    secure
  })
}

export function getCookie(string) {
  return Cookie.get(string)
}

export function removeCookie(string) {
  const domain = getDomain()
  const secure = needSecure(window.location.protocol)

  Cookie.remove(string, {
    domain,
    secure
  })
}

export function setItemToStorage(string, value) {
  try {
    window.localStorage.setItem(string, value)
  } catch (e) {
    return
  }
}

export function getItemFromStorage(string) {
  try {
    const json = window.localStorage.getItem(string)
    return json
  } catch (e) {
    return null
  }
}

export function clearStorage() {
  try {
    window.localStorage.clear()
  } catch (e) {
    return
  }
}

export function getDomain() {
  let hostname = getDomainName(document.location.hostname)
  hostname = hostname.indexOf('localhost') >= 0 ? hostname : `.${hostname}`
  return hostname.indexOf('ine.com') >= 0 ? '.ine.com' : hostname
}

export function needSecure(protocol) {
  return protocol.indexOf('https') >= 0
}

// PRIVATE FUNCTIONS
function getDomainName(hostName) {
  return hostName.substring(
    hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1
  )
}